module.exports = function() {
  return new Worker(__webpack_public_path__ + "aae07f09fef0c834bbfb.worker.js");
};